<template>
  <div class="do-kindergarten__color-picker">
    {{ hours }}
  </div>
</template>
<script>
export default {
  props: {
    hours: {
      default: 0
    },
    openingHours: {
      default: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// DutySchedulePlanCalendarDayStats.vue?5f2e21e6